import { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const FALLBACK = [
  { q: "What areas does Julicare serve?", a: "Greater Toronto Area (GTA) and surrounding regions." },
  { q: "Are your caregivers certified and insured?", a: "Yes. Every caregiver is trained, insured and background-checked." },
  { q: "Do you offer 24/7 care?", a: "Yes, including hourly visits, overnight, live-in, and round-the-clock coverage." },
  { q: "How do you protect privacy?", a: "We follow PIPEDA and HIPAA-conscious privacy practices." },
];

export default function FAQ() {
  const [items, setItems] = useState(FALLBACK);

  useEffect(() => {
    axios
      .get(`${API}/faq`)
      .then((r) => Array.isArray(r.data) && r.data.length && setItems(r.data))
      .catch(() => {});
  }, []);

  return (
    <section id="faq" className="py-20 md:py-32 bg-[#F8FAFC]" data-testid="faq-section">
      <div className="container-pad mx-auto max-w-5xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6 }}
          className="max-w-2xl mb-10 md:mb-14"
        >
          <p className="text-xs md:text-sm uppercase tracking-[0.2em] font-bold text-[#2A9D8F] mb-5">
            Frequently Asked
          </p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#0F2942] leading-[1.1]">
            Answers, before the appointment.
          </h2>
        </motion.div>

        <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
          {items.map((it, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="bg-[#EEF4F8] rounded-2xl border-0 px-6"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="font-serif text-lg md:text-xl text-[#0F2942] hover:no-underline py-5">
                {it.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#475569] text-base leading-relaxed pb-5">
                {it.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
